export default __webpack_public_path__ + "2f7029a6e847e52da4aee19b2ee97086.svg";